import { render, staticRenderFns } from "./referrer-talks-detail.vue?vue&type=template&id=ca6bf440&scoped=true&"
import script from "./referrer-talks-detail.vue?vue&type=script&lang=js&"
export * from "./referrer-talks-detail.vue?vue&type=script&lang=js&"
import style0 from "./referrer-talks-detail.vue?vue&type=style&index=0&id=ca6bf440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6bf440",
  null
  
)

export default component.exports